:host {
  overflow: hidden;
  width: 100%;
  padding: 14px 18px;
  background-color: var(--theme-secondary-background);
  border-radius: 4px;
  display: flex;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
}

:host(:hover) {
  border-color: var(--theme-primary-border);
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.4);
}

:host(:hover) slot[name='title']::slotted(*) {
  color: var(--theme-link-text);
}
